import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';

class InnerHTML extends React.Component {
  constructor() {
    super();
    this.state = {
      clientSide: false,
      data: '',
    };
  }
  componentDidMount() {
    this.setState({ clientSide: true });
    this.getInnerHtml();
  }

  getInnerHtml = () => {
    if (this.props.data && this.props.data.path) {
      makeRequest.get(this.props.data.path, {}, 'skipfeedengine').then(res => {
        if (res && res.data) {
          this.setState({ data: res.data });
        }
      });
    }
  };

  render() {
    if (!this.state.clientSide) {
      return false;
    }

    return (
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: this.state.data,
        }}
      />
    );
  }
}

InnerHTML.propTypes = {
  data: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

export default InnerHTML;
